export default __webpack_public_path__ + "static/media/New India.ec9650c4.png";